module.exports = __webpack_public_path__ + "img/animation1.c67b8cdc.png";